import {
  getDefaultSelectedKey,
  getMenuItems,
} from '@/Layouts/Sidebar/Sidebar.helpers';
import { useTypedSelector } from '@/hooks/useTypedSelector';
import { Menu } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

type Props = {
  isMobile?: boolean;
  onCloseMobileMenu: () => void;
};

const styleBackground = {
  backgroundColor: '#0e0e0fa8',
  backgroundImage: 'radial-gradient(#3b3e5b 1px, #181819 1px)',
  backgroundSize: '20px 20px',
};

export const NavLinks: React.FC<Props> = ({ isMobile, onCloseMobileMenu }) => {
  const navigate = useNavigate();
  const { countMessages } = useTypedSelector((state) => state.chat);

  const { userInfo } = useTypedSelector((state) => state.registration);
  const [selectedKeys, setSelectedKeys] = useState<string[]>(['']);

  const handleNavigateLink = (menuItemLink: string): void => {
    setSelectedKeys([menuItemLink]);
    navigate(menuItemLink);
  };

  const menuItems = getMenuItems(
    handleNavigateLink,
    userInfo,
    countMessages,
    onCloseMobileMenu,
  );

  useEffect(() => {
    setSelectedKeys(getDefaultSelectedKey(location.pathname));
  }, []);

  return (
    <Menu
      style={isMobile ? undefined : styleBackground}
      defaultSelectedKeys={getDefaultSelectedKey(location.pathname)}
      selectedKeys={selectedKeys}
      theme={isMobile ? 'light' : 'dark'}
      mode="inline"
      items={menuItems}
    />
  );
};
